
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Create, GetEmployeeList } from "adminApi/AwardApi/AwardApi";
import { validateForm } from "utils/validation";
import { AwardRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddAwardForm from "./components/AddAwardForm";
import fields from "../json/Award.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";

const AddAward = () => {
    const navigate = useNavigate();
    const { formdata } = fields;

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors } = useFormChange(
        initialValues,
        AwardRules
    );

    const { data: employeeOptions, loading: loadingEmployees } = useFetchAllData(GetEmployeeList);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Create({ data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, AwardRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Award created successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingEmployees) && <Spinner isSpinner={true} />}
            <AddAwardForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                employeeOptions={employeeOptions}
            />
        </>
    );
};

export default AddAward;
